import React, { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import SEO from '../../components/SEO';
import NavExpander from '../../containers/NavExpander';
import Recirc from '../../components/Recirc';
import PageContent from './PageContent';
import styles from './page.css';

const InspirationPost = ({ path, title, content, themeColors, recircPost }) => {
  const contentRef = useRef(null);

  const setTheme = () => {
    const contentEl = contentRef.current;

    if (contentEl && themeColors) {
      const { primary_color, recirc_color } = themeColors;
      primary_color && contentEl.style.setProperty('--primary', primary_color);
      recirc_color && contentEl.style.setProperty('--recirc', recirc_color);
    }
  };

  useEffect(() => {
    setTheme();
  }, []);

  const backgroundColor = themeColors && themeColors.background_color;

  return (
    <div className={styles.page}>
      <SEO title={title} path={path} />
      <NavExpander footerColor={backgroundColor}>
        <section className={styles.wrapper} style={backgroundColor ? { backgroundColor } : {}}>
          <div ref={contentRef} className={`${styles.content} default`}>
            <PageContent header={{ overline: 'Inspiration Nation', title }} content={content} />
            {recircPost && (
              <Recirc
                subtitle="Inspiration Nation"
                title={recircPost.title}
                link={recircPost.path}
              />
            )}
          </div>
        </section>
      </NavExpander>
    </div>
  );
};

InspirationPost.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  themeColors: PropTypes.object,
  recircPost: PropTypes.object,
};

export default withRouter(InspirationPost);
